import { TranslateService } from '@ngx-translate/core';
import { OnInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

/**
 * Define the CharCount Directive.
 */
@Directive({
  selector: '[appCharCount]',
})
/**
 * CharCount Class.
 */
export class CharCountDirective implements OnInit {
  constructor(private el: ElementRef, private translate: TranslateService) {
   this.label= this.translate.instant("Common.CharactersLeft")
   
  }

   label: any ="" 
  @Input("limit") limit: any = 250;
  @Input("showinitial") showinitial: any = false;
  ngOnInit() {

    this._countDisplay = document.getElementById("char-count")
    document.getElementById("char-count").classList.add("char-count")
    if (this.showinitial)
      document.getElementById("char-count").innerText = this.label + ":" + this.limit;

      this.translate.onLangChange.subscribe(res => {
       
      this.label =  this.translate.instant("Common.CharactersLeft")
      if(document.getElementById("char-count")!=undefined)
      document.getElementById("char-count").innerText = this.label + ":" + this.limit;
      })
      document.getElementById("char-count").innerText = this.label + ":" + (this.limit - (this.el.nativeElement.value.length));
  }


  private _countDisplay: any;
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {

    if (this.limit - (this.el.nativeElement.value.length) <= 0) {
      event.preventDefault();
      return false;
    }
  }
  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {

    let e = event;
    if (this.limit - (this.el.nativeElement.value.length) < 0) {
      e.preventDefault();
      return false;
    }
    if ((this.el.nativeElement.value.length + 1) > this.limit) {


      if (!(event.keyCode == 46 || event.keyCode == 8)) {
        if (this.el.nativeElement.value.length == this.limit)
          document.getElementById("char-count").innerText = this.label + ":" + 0;


        e.preventDefault();
        return true;
      }


    }
    if (this.el.nativeElement.value.length == this.limit) {
      document.getElementById("char-count").innerText = this.label + ":" + 0;
      return
    }
    document.getElementById("char-count").innerText = this.label + ":" + (this.limit - (this.el.nativeElement.value.length));
    return true;



  }

}
